if(document.querySelector("#properties_hardware_color")) {
  document.querySelector("#properties_hardware_color").addEventListener("change", function() {
    console.log(this.value);
    document.querySelector(".properties_hardware_color_value").value = this.value;
  });
}


if(document.querySelector("#properties_leather_color")) {
  document.querySelector("#properties_leather_color").addEventListener("change", function() {
    console.log(this.value);
    document.querySelector(".properties_leather_color_value").value = this.value;
  });
}

if(document.querySelector("#properties_fastening_color")) {
  document.querySelector("#properties_fastening_color").addEventListener("change", function() {
    console.log(this.value);
    document.querySelector(".properties_fastening_color_value").value = this.value;
  });
}

if(document.querySelector("#properties_fitting_color")) {
  document.querySelector("#properties_fitting_color").addEventListener("change", function() {
    console.log(this.value);
    document.querySelector(".properties_fastening_color_value").value = this.value;
  });
}